export const visitesConstants = {
  GET_VISITES: "GET_VISITES",
  GET_TENDANCES: "GET_TENDANCES",
};
